<template>
  <a class="p-button p-button-primary rounded-button p-component p-px-1 p-px-md-4 p-py-0 p-py-md-1" href="#" @click.prevent="activateGeolocation">
    <span class="p-d-none p-d-md-inline pi pi-map-marker p-button-icon p-button-icon-right"></span>
    <span class="p-button-label">{{ buttonText }}</span>
  </a>
</template>

<script>
export default {
  name: "GeolocationButton.vue",
  data() {
    return {
      buttonText: "Géolocalisez-moi",
      location: null
    };
  },
  created() {

  },
  methods: {
    activateGeolocation() {
      this.buttonText = "...";

      // Get user location
      navigator.geolocation.getCurrentPosition(position => {
        this.buttonText = "Localisation activée";
        this.location = position;
        this.$emit('get-coordinates', this.location);
      }, err => {
        this.buttonText = "Erreur de géolocalisation";
        console.log(err.message);
      });
    }
  }
}
</script>

<style scoped>

</style>
